import { type ReactNode } from 'react';
import styles from './collapsible-drawer.module.scss';

export const CollapsibleDrawer = ({
	heading,
	children,
	titlePadding = 'var(--spacing-xxs)',
	open = true,
	...restProps
}: Props) => {
	const componentStyles = {
		'--title-padding': titlePadding,
	} as React.CSSProperties; // "--title-padding" is our own variable, so the default types don't know about it, hence use "as"

	return (
		<div style={componentStyles} {...restProps}>
			<details className={styles.details} open={open}>
				<summary className={styles.summary}>{heading}</summary>
				{children}
			</details>
		</div>
	);
};

interface Props {
	open: boolean;
	children: ReactNode;
	heading: ReactNode;
	titlePadding?: string;
}

export default CollapsibleDrawer;
